import React from "react";
import { useAppStore } from "@/store/appStore";
import ImageButton from "./image-button";

const ShareButtonBase = () => {
  const setIsShareOpen = useAppStore((state) => state.setIsShareOpen);
  const isChatOpen = useAppStore((state) => state.isChatOpen);
  const setIsChatOpen = useAppStore((state) => state.setIsChatOpen);

  const generateShareLink = async () => {
    if (isChatOpen) {
      setIsChatOpen(false);
    }

    setIsShareOpen(true);
  };

  return (
    <>
      <ImageButton
        className="button-glass"
        src="/assets/icon_share.png"
        onClick={() => generateShareLink()}
        alt="share button"
        size={24}
      />
    </>
  );
};

export const ShareButton = React.memo(ShareButtonBase);
